var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132,
    height: 133,
    viewBox: "0 0 132 133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12840",
    "data-name": "Group 12840",
    transform: "translate(907 -11201)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_395",
    "data-name": "Ellipse 395",
    cx: 66,
    cy: 66.5,
    rx: 66,
    ry: 66.5,
    transform: "translate(-907 11201)",
    fill: "#fdeebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "call_12_",
    "data-name": "call (12)",
    d: "M48.088,42.427c-1.512,4.593-7.433,6.885-11.664,6.5-5.778-.522-12.066-3.588-16.839-6.963A55.461,55.461,0,0,1,2.168,21.184C-.538,15.428-1.145,8.351,2.88,3.1A6.922,6.922,0,0,1,8.4.01c3.356-.163,3.826,1.756,4.979,4.747.859,2.236,2,4.518,2.644,6.836,1.2,4.326-2.99,4.505-3.519,8.041-.326,2.23,2.373,5.22,3.594,6.81a32.989,32.989,0,0,0,8.514,7.845c1.861,1.172,4.858,3.284,6.986,2.119,3.278-1.8,2.971-7.322,7.551-5.452a73.747,73.747,0,0,1,6.937,3.581c3.5,1.884,3.34,3.836,2,7.891h0",
    transform: "translate(-865.484 11243.515)",
    fill: "#4c5b71",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/CallIcon.cc903e6fa12c5d6a9753043282c8cd5b.svg";
export { ForwardRef as ReactComponent };